
/** 
 * Definition of the initial state of the reducer 
*/
const initialState: any = {
	user: null,
	restaurant: null
};

/** Definition of the current state of the reducer */
const currentState: any = { ...initialState };

/**
 * @description Executes the differents action about the routing
 * @param state The current state of the configuration
 * @param action to perform on the current state
 * @returns the state updated with the action performed
 */
const userReducer = (state = currentState, action: any) => {
	switch (action.type) {
	case 'SET_USER':
		return { ...state, user: action.payload.user, restaurant: null };
    case 'REMOVE_USER':
		return { ...state, user: null, restaurant: null };
	case 'SET_RESTAURANT':
		return { ...state, restaurant: { ...action.payload.restaurant } };
	case 'UNSET_RESTAURANT':
		return { ...state, restaurant: null };
	case 'RESET':
		return { ...initialState };
	default:
		return state;
	}
};

export default userReducer;